<template>
  <div
    class="ddrow"
    :class="{ 'ddrow-exp': d.expired }"
    :style="{ borderInlineStartColor: d.color }"
    @click="$emit('select', device)"
  >
    <div class="ddrow-top">
      <div
        class="dd-ava"
        :style="{ background: d.color }"
      >
        <v-icon
          color="#fff"
          size="21"
        >
          {{ d.avatarIcon }}
        </v-icon>
      </div>
      <div class="dd-main">
        <div class="dd-nm">
          {{ device.title }}
        </div>
        <div class="dd-ow">
          {{ ownerName }}<template v-if="d.expired"> · اشتراک منقضی</template>
        </div>
      </div>

      <span
        v-if="d.expired"
        class="dd-pill dd-pill-red"
      >
        <v-icon
          size="14"
          color="#9a2a2b"
        >mdi-alert-circle-outline</v-icon> منقضی
      </span>
      <button
        v-else
        class="dd-setbtn"
        :class="{ open: menuOpen }"
        @click.stop="menuOpen = !menuOpen"
      >
        <v-icon size="15">mdi-cog</v-icon> تنظیمات
        <v-icon size="14">{{ menuOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </button>
    </div>

    <div
      v-if="!d.expired"
      class="dd-ind"
    >
      <span
        class="dd-tag"
        :class="d.online ? 'ddt-green' : 'ddt-gray'"
      >
        <v-icon size="15">{{ d.online ? 'mdi-access-point' : 'mdi-access-point-network-off' }}</v-icon>
        <b>{{ d.online ? 'آنلاین' : 'آفلاین' }}</b>
      </span>
      <span
        class="dd-tag"
        :class="moveCls"
      >
        <v-icon size="15">{{ d.move.icon }}</v-icon>{{ d.move.label }}
      </span>
      <span
        class="dd-tag"
        :class="d.loc.cls"
      >
        <v-icon size="15">{{ d.loc.icon }}</v-icon>{{ d.loc.label }}
      </span>
    </div>

    <div class="dd-ids">
      <span><v-icon size="14">mdi-identifier</v-icon> شناسهٔ دستگاه: <code>{{ device.imei }}</code></span>
      <span v-if="device.sim"><v-icon size="14">mdi-sim</v-icon> سیم‌کارت: <code>{{ device.sim }}</code></span>
    </div>

    <div
      v-if="menuOpen && !d.expired"
      class="dd-setmenu"
      @click.stop
    >
      <button
        v-for="(row, i) in menuItems"
        :key="i"
        class="dd-setitem"
        @click.stop="onAction(row)"
      >
        <v-icon size="16">{{ row.icon }}</v-icon> {{ row.title }}
      </button>
    </div>

    <div
      v-if="d.expired"
      class="dd-renew"
    >
      <span class="dd-renew-txt">برای ادامهٔ ردیابی اشتراک را تمدید کنید</span>
      <button
        class="dd-renewbtn"
        @click.stop="$emit('renew', device)"
      >
        <v-icon
          size="15"
          color="#fff"
        >mdi-refresh</v-icon> تمدید اکانت
      </button>
    </div>
  </div>
</template>

<script>
import { deviceDisplay } from '@/utils/deviceDisplay'

export default {
  name: 'DeviceRow',
  props: {
    device: { type: Object, required: true },
    menuItems: { type: Array, default: () => [] },
  },
  data() {
    return { menuOpen: false }
  },
  computed: {
    d() {
      return deviceDisplay(this.device)
    },
    ownerName() {
      const u = this.device && this.device.userId
      if (u && typeof u === 'object') return `${u.name || ''} ${u.family || ''}`.trim()
      return ''
    },
    moveCls() {
      return {
        move: 'ddt-green', idle: 'ddt-green', park: 'ddt-amber', tow: 'ddt-red', off: 'ddt-gray',
      }[this.d.kind] || 'ddt-gray'
    },
  },
  methods: {
    onAction(row) {
      this.menuOpen = false
      this.$emit('action', { action: row.action, device: this.device })
    },
  },
}
</script>

<style scoped>
.ddrow{padding:12px 14px;border-bottom:1px solid #ebe9f1;border-inline-start:3px solid transparent;cursor:pointer;overflow:hidden}
.ddrow:hover{background:#faf9ff}
.ddrow-exp{background:#fff7f7}
.ddrow-top{display:flex;align-items:center;gap:11px}
.dd-ava{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex:none}
.dd-main{flex:1;min-width:0}
.dd-nm{font-weight:700;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.dd-ow{font-size:12px;color:#6e6b7b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ddrow-exp .dd-ow{color:#9a2a2b}
.dd-setbtn{display:inline-flex;align-items:center;gap:5px;padding:6px 10px;border-radius:9px;border:1px solid #d8d6e0;background:#fff;color:#2f2b3d;font-size:12px;font-family:inherit;white-space:nowrap;cursor:pointer;flex:none}
.dd-setbtn:hover,.dd-setbtn.open{background:#f6f5ff;border-color:#c9c4f5}
.dd-pill{display:inline-flex;align-items:center;gap:5px;font-size:12px;padding:3px 9px;border-radius:20px;flex:none}
.dd-pill-red{background:#fde6e6;color:#9a2a2b}
.dd-ind{display:flex;flex-wrap:wrap;gap:7px;margin-top:9px;padding-inline-start:51px}
.dd-tag{display:inline-flex;align-items:center;gap:5px;font-size:12px;padding:4px 9px;border-radius:8px;background:#f4f4f8;color:#5b5b5b;max-width:100%}
.dd-tag b{font-weight:700}
.ddt-green{background:#e5f8ee;color:#1b7a44}
.ddt-amber{background:#fff2e2;color:#9a5a10}
.ddt-red{background:#fde6e6;color:#9a2a2b}
.ddt-gray{background:#eef0f2;color:#5b5b5b}
.dd-ids{margin-top:8px;padding-inline-start:51px;font-size:11.5px;color:#6e6b7b;display:flex;flex-wrap:wrap;gap:6px 14px}
.dd-ids code{font-family:inherit;direction:ltr;unicode-bidi:embed}
.dd-setmenu{display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-top:10px;padding-inline-start:51px}
.dd-setitem{display:flex;align-items:center;gap:7px;font-size:12px;padding:9px 10px;border:1px solid #ebe9f1;border-radius:8px;background:#fff;color:#2f2b3d;font-family:inherit;cursor:pointer;text-align:start}
.dd-setitem:hover{background:#f6f5ff;border-color:#c9c4f5}
.dd-setitem .v-icon{color:#5e50ee}
.dd-renew{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:9px;padding-inline-start:51px;flex-wrap:wrap}
.dd-renew-txt{font-size:12px;color:#9a2a2b}
.dd-renewbtn{display:inline-flex;align-items:center;gap:5px;padding:6px 12px;border-radius:9px;border:none;background:#ea5455;color:#fff;font-size:12px;font-family:inherit;cursor:pointer}
.dd-ind .v-icon,.dd-ids .v-icon{vertical-align:-2px}
</style>
